export default __webpack_public_path__ + "static/media/reckless-light-webfont.f7877b90.woff";